// @ts-nocheck
/**
 * Returns the description of an amenity.
 * If the description is empty, it returns an empty string.
 *
 * @param {Object} amenity - The amenity object.
 * @returns {string} The description of the amenity.
 */
export const isAmenityDescriptionEmpty = (amenity) => {
  if (amenity?.description === '<p></p>') {
    return true;
  }
  if (amenity?.description === null || amenity?.description === undefined) {
    return true;
  }
  return amenity?.description?.length === 0;
};
